var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFacebook = function SvgIconFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5776 19.875V26H20.1347V19.875H22.0413L22.4041 17.3413H20.1347V15.6971C20.1347 15.0039 20.4517 14.3283 21.4682 14.3283H22.5V12.1712C22.5 12.1712 21.5636 12 20.6683 12C18.7992 12 17.5776 13.2134 17.5776 15.4102V17.3413H15.5V19.875H17.5776Z",
    fill: "#2F2F4B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 18,
    stroke: "#2F2F4B",
    strokeWidth: 1.5
  })));
};
export default SvgIconFacebook;